import { FolderUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
//TODO: translate
const VoidView = () => {
    const { t } = useTranslation();
    return (
        <div className="flex h-full w-full min-h-[inherit] justify-center items-center mt-auto mb-auto">
            <div className="flex flex-col items-center justify-center">
                <FolderUp className="h-24 w-24 mb-4" />
                <p>{t('knowledgeManager.thereAreNoDocuments')}</p>
            </div>
        </div>
    );
};

export default VoidView;
